import { createRouter, createWebHashHistory } from 'vue-router';

// import Home from '@/views/Home.vue';
// @ts-ignore
const Home = () => import('@/views/Home.vue') as any;

// Translation
// @ts-ignore
import i18n from '@/i18n';
// @ts-ignore
import Tr from '@/i18n/translation';

const base_url = '/';

const routes = [
    {
        path: base_url,
        name: 'Home',
        component: Home,
        props: true,
        meta: {},
        // @ts-ignore
        async beforeEnter(to, from) {
            const paramsLocale = Tr.guessDefaultLocale();
            if (!i18n.global.availableLocales.includes(paramsLocale)) {
                // console.log('loading locale:', paramsLocale);
                await Tr.switchLanguage(paramsLocale);
            }
        },
    },
    {
        path: base_url + 'login',
        name: 'Login',
        // @ts-ignore
        component: () => import('@/views/Login.vue') as any,
        props: true,
        meta: {},
        // @ts-ignore
        async beforeEnter(to, from) {
            const paramsLocale = Tr.guessDefaultLocale();
            if (!i18n.global.availableLocales.includes(paramsLocale)) {
                await Tr.switchLanguage(paramsLocale);
            }
        },
    },
    {
        path: base_url + ':pathMatch(.*)*',
        name: 'NotFound',
        // @ts-ignore
        component: () => import('@/views/NotFound.vue') as any,
    },
];

import { getCurrentUser } from 'vuefire';

const router = createRouter({
    history: createWebHashHistory(), // createWebHistory(base_url_env_history),
    // base: base_url_env_history,
    routes,
    // @ts-ignore
    scrollBehavior(to, from, savedPosition) {
        return (
            savedPosition ||
            new Promise((resolve) => {
                setTimeout(() => resolve({ top: 0 }), 300);
            })
        );
    },
});

router.beforeEach(async (to) => {
    const currentUser = await getCurrentUser();

    if (!currentUser && to.name !== 'Login') {
        return { name: 'Login' };
    }
});

export default router;
